var isMobile = checkIfMobile();
var headerSection = $('#header-section');
var cardsMenuContainer = $('#cards-menu-container');
var loansMenuContainer = $('#loans-menu-container');
var menuOverlay = $('.menu-overlay');
var menuGuides = $('.menu-guides');
var colMenu = $('.menu-guides .col-menu');
var colSubMenu = $('.menu-guides .col-submenu');
var colMenuItem = $('.menu-guides .col-menu .menu-item');
var menuMobileBackButton = $('#top_menu_mobile_back_button');
var setDefaultNavMenu = true;

window.addEventListener('resize', function () {
    isMobile = checkIfMobile();
    if (!isMobile) {
        if ($('.mobile-nav').hasClass('show')) {
            $('.bar').toggleClass('animate');
            $('.mobile-nav').toggleClass('hide-away show');
        }
    } else {
        isMobile = true;
    }
});

function checkIfMobile() {
    return window.matchMedia("only screen and (max-width: 991px)").matches;
}

if (headerSection.length === 1) {
    if (isMobile) {
        headerSection.addClass('mobile');
        $(document).on('click', '.menu-guides .col-menu .menu-item', function (event) {
            showNavSubMenu(this);
        });
        $(document).on('click', '#menu-header-text-container', function (event) {
            showNavMenu();
        });
    } else {
        hideNavMenus();
        headerSection.addClass('desktop');
        $(document).on('mouseenter', '#page_header ul.links a, .menu-overlay', function (event) {
            hideNavMenus();
        });
        $(document).on('mouseenter', '#page_header ul.links a#guides-link', function (event) {
            showNavMenu();
        });
        $(document).on('mouseenter', '#page_header ul.links a#loans-menu-link', function (event) {
            showLoansNavMenu();
        });
        $(document).on('mouseenter', '#loans-menu-container .col-menu .menu-item', function (event) {
            showNavSubMenu(this);
        });
        $(document).on('mouseenter', '#cards-menu-container .col-menu .menu-item', function (event) {
            showNavSubMenu(this);
        });
    }
}

function showNavMenu() {
    headerSection.addClass('open');
    cardsMenuContainer.removeClass('hidden', 'fade');
    if (isMobile) {
        colSubMenu.addClass('hidden-sm hidden-xs');
        colMenu.removeClass('hidden');
        menuMobileBackButton.addClass('hidden');
    } else {
        menuOverlay.removeClass('hidden');
        if (setDefaultNavMenu) {
            menuGuides.find('.col-menu a .menu-item:nth-of-type(1)').addClass('active');
            menuGuides.find('.col-submenu .submenu:nth-of-type(1)').removeClass('hidden');
            setDefaultNavMenu = false;
        }
    }
    setTimeout(function () {
        cardsMenuContainer.addClass('in');
        if (!isMobile) {
            menuOverlay.addClass('in');
        }
    }, 10);
}
function showLoansNavMenu() {
    headerSection.addClass('open');
    loansMenuContainer.removeClass('hidden', 'fade');
    if (isMobile) {
        colSubMenu.addClass('hidden-sm hidden-xs');
        colMenu.removeClass('hidden');
        menuMobileBackButton.addClass('hidden');
    } else {
        menuOverlay.removeClass('hidden');
        // Set default nav menu on desktop
        if (setDefaultNavMenu) {
            menuGuides.find('.col-menu a .menu-item:nth-of-type(1)').addClass('active');
            menuGuides.find('.col-submenu .submenu:nth-of-type(1)').removeClass('hidden');
            setDefaultNavMenu = false;
        }
    }
    setTimeout(function () {
        loansMenuContainer.addClass('in');
        if (!isMobile) {
            menuOverlay.addClass('in');
        }
    }, 10);
}

function showNavSubMenu(menuElement) {
    var menuItemIndex = $(menuElement).index() + 1;
    if (isMobile) {
        colMenu.addClass('hidden');
        menuMobileBackButton.removeClass('hidden');
    } else {
        colMenuItem.removeClass('active');
        $(menuElement).addClass('active');
    }
    colSubMenu.removeClass('hidden-sm hidden-xs');
    colSubMenu.find('.submenu').addClass('hidden');
    colSubMenu.find('.submenu:nth-of-type(' + menuItemIndex + ')').removeClass('hidden');
}

function hideNavMenus() {
    headerSection.removeClass('open');
    cardsMenuContainer.removeClass('in').addClass('hidden');
    loansMenuContainer.removeClass('in').addClass('hidden');
    menuOverlay.removeClass('in').addClass('hidden');
    if (isMobile) {
        colMenu.show();
        colSubMenu.addClass('hidden-sm hidden-xs');
        colSubMenu.find('.submenu').addClass('hidden');
        $('html, body').removeAttr('style');
    }
}

(function () {
    $('.hamburger-menu').on('click', function () {
        toggleMobileMenu();
    });

    $('.submenu .menu-item').on('click', function () {
        closeMobileMenu();
    });

    $('.col-menu a').on('click', function () {
        closeMobileMenu();
    });

    $(window).on('beforeunload', function() {
        closeMobileMenu();
    });

    function toggleMobileMenu() {
        $('.bar').toggleClass('animate');
        $('.mobile-nav').toggleClass('hide-away show');
        $('html, body').toggleClass('overflow-hidden');
    }

    function closeMobileMenu() {
        if ($('.mobile-nav').hasClass('show')) {
            $('.bar').removeClass('animate');
            $('.mobile-nav').removeClass('show').addClass('hide-away');
            $('html, body').removeClass('overflow-hidden');
        }
    }
})();
